import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { AccessRequestNode } from '../../fragments/generated/AccessRequestNode';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetAccessRequestByIdQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
  accessRequestId: Types.Scalars['ID']['input'];
}>;


export type GetAccessRequestByIdQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, accessRequest?: { __typename?: 'AccessRequest', id?: string | null, requestedAt?: string | null, hasAccountUser?: boolean | null, hasMemberLicense?: boolean | null, requestedResource?: { __typename?: 'Collection', id: string, name: string, collectionProject: { __typename?: 'Project', id: string, name: string } } | { __typename?: 'FileAsset', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null } | { __typename?: 'FolderAsset', id: string, name: string, folderAssetProject?: { __typename?: 'Project', id: string, name: string } | null, project?: { __typename?: 'Project', id: string, name: string } | null } | { __typename?: 'Project', id: string, name: string } | { __typename?: 'VersionStackAsset', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null } | null, requesterUser?: { __typename?: 'UserInfo', id: string, email: string, name?: string | null, profileImageUrl?: string | null, avatarColor?: Types.AvatarColor | null } | null } | null } | null };


export const GetAccessRequestById = /*#__PURE__*/ gql`
    query GetAccessRequestById($accountId: ID!, $accessRequestId: ID!) {
  account(accountId: $accountId) {
    id
    accessRequest(id: $accessRequestId) {
      ...AccessRequestNode
    }
  }
}
    ${AccessRequestNode}` as unknown as DocumentNode<GetAccessRequestByIdQuery, GetAccessRequestByIdQueryVariables>;

          

          export const useGetAccessRequestByIdQuery = (options?:QueryHookOptions<GetAccessRequestByIdQuery, GetAccessRequestByIdQueryVariables>) => useQuery(GetAccessRequestById, options);

          

          export type GetAccessRequestByIdQueryOptions = QueryHookOptions<GetAccessRequestByIdQuery, GetAccessRequestByIdQueryVariables>;

          

          export const useGetAccessRequestByIdLazyQuery = (options?:LazyQueryHookOptions<GetAccessRequestByIdQuery, GetAccessRequestByIdQueryVariables>) => useLazyQuery(GetAccessRequestById, options);

          

          export type GetAccessRequestByIdQueryResult = ReturnType<typeof useGetAccessRequestByIdQuery>;

          
